import React, { useState } from "react";
import styled from "styled-components";
import Box from "../../components/Box";
import Textfield from "../../components/Merchant/Textfield";
import TextfieldWithImage from "../../components/ManageOutlet/TextFieldWithImage";
import countryCodeData from "../AddPark/countries";
import Selectfield from "../../components/Merchant/Selectfield";
import Button from "../../components/Button";
import { Colors } from "../../config/Constants";
import RegisterImageUpload from "../../components/RegisterImageUpload";
import { uploadEventImage } from "../../services/eventsService";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { validateRegAMDData } from "../../helper";
import { membershipRegister } from "../../services/amdServices";
import { useLoadContext } from "../../contexts/LoadContext";

function getFlagName(countryCode: string) {
  let newArr = countryCodeData.filter(
    (eachData) => eachData.callingCode === countryCode
  );
  if (newArr.length) return newArr[0].flag;
  else return require(`../../assets/images/flags/qa.png`);
}

const RegisterAMDMembership = () => {
  const { setLoader } = useLoadContext();
  const [data, setData] = useState({
    name: "",
    lastname: "",
    email: "",
    phone: "",
    countryCode: "974",
    carPlateNo: "",
    carBrand: "",
    carModel: "",
    carType: "",
    carMake: "",
    carColor: "",
    carPhoto: "",
    istimaraPhoto: "",
    adminRequest: true,
  });

  const [formError, setFormError] = useState({
    name: "",
    lastname: "",
    email: "",
    phone: "",
    countryCode: "",
    carPlateNo: "",
    carBrand: "",
    carModel: "",
    carType: "",
    carMake: "",
    carColor: "",
    carPhoto: "",
    istimaraPhoto: "",
  });

  const navigate = useNavigate();

  const handleFileUpload = async (e: any, name: string) => {
    if (e[0].size > 2048756) {
      toast.error("File size should be 2MB");
    } else {
      try {
        let res = await uploadEventImage(e[0]);
        setData({ ...data, [name]: res?.data.files[0] });
        setFormError({ ...formError, [name]: "" });
      } catch (err) {
      } finally {
      }
    }
  };

  const handleFormChange = (e: any) => {
    setData({ ...data, [e.target.name]: e.target.value });
    setFormError({ ...formError, [e.target.name]: "" });
  };

  const handleSubmitData = async () => {
    let postableObj = JSON.parse(JSON.stringify(data));
    // @ts-ignore
    postableObj.istimaraPhoto = data?.istimaraPhoto?.viewUrl;
    // @ts-ignore
    postableObj.carPhoto = data?.carPhoto?.viewUrl;
    console.log(postableObj);
    if (validateRegAMDData(postableObj, setFormError)) {
      setLoader(true);
      try {
        let res = await membershipRegister(postableObj);
        toast.success("Successfully Registered");
        setData({
          name: "",
          lastname: "",
          email: "",
          phone: "",
          countryCode: "974",
          carPlateNo: "",
          carBrand: "",
          carModel: "",
          carType: "",
          carMake: "",
          carColor: "",
          carPhoto: "",
          istimaraPhoto: "",
          adminRequest: true,
        });
      } catch (err: any) {
        toast.error(err?.message);
      } finally {
        setLoader(false);
      }
    } else {
      toast.error("Please check all the fields");
    }
  };

  return (
    <Container>
      <div
        style={{
          padding: "0 1rem",
          display: "flex",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        <Button
          width="100px"
          variant="outlined"
          label="Back"
          onClick={() => navigate(`/admin/amd-membership`)}
        />
        <Header>Register Member</Header>
      </div>
      <Box>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="name"
                label="Owner First Name"
                placeholder="First Name"
                onChange={handleFormChange}
                value={data?.name}
                required
                helperText={formError["name"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="lastname"
                label="Owner Last Name"
                placeholder="Last Name"
                onChange={handleFormChange}
                value={data?.lastname}
                required
                helperText={formError["lastname"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="email"
                label="Email"
                placeholder="Enter Email"
                onChange={handleFormChange}
                value={data?.email}
                required
                helperText={formError["email"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <TextfieldWithImage
                inputName="phone"
                selectName="countryCode"
                label="Mobile Number"
                placeholder="Mobile number"
                onChange={handleFormChange}
                inputValue={data?.phone}
                selectValue={data?.countryCode}
                required={false}
                helperText={formError["countryCode"] || formError["phone"]}
                imageLink={
                  data.countryCode === ""
                    ? require(`../../assets/images/flags/qa.png`)
                    : getFlagName(data.countryCode)
                }
                selectData={countryCodeData}
                type={"dropdown"}
              />
            </FieldWrapper>
          </FormRow>
        </FormWrapper>
      </Box>
      <NoShadowBox>
        <div
          style={{
            marginTop: "0.5rem",
            marginBottom: "0.25rem",
            fontSize: "20px",
          }}
        >
          Car Details
        </div>
      </NoShadowBox>

      <NoShadowBox>
        <FormWrapper>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="carPlateNo"
                label="Car Plate Number"
                placeholder="Enter Plate number"
                onChange={handleFormChange}
                value={data?.carPlateNo}
                required
                helperText={formError["carPlateNo"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="carBrand"
                label="Car Brand"
                placeholder="Enter Car Brand"
                onChange={handleFormChange}
                value={data?.carBrand}
                required
                helperText={formError["carBrand"]}
              />
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="carModel"
                label="Car Model"
                placeholder="Enter Model"
                onChange={handleFormChange}
                value={data?.carModel}
                required
                helperText={formError["carModel"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="carType"
                label="Car Type"
                placeholder="Enter Car Type"
                onChange={handleFormChange}
                value={data?.carType}
                required
                helperText={formError["carType"]}
              />
              {/* <Selectfield
              name="carType"
              label="Car Type"
              onChange={handleFormChange}
              value={data.carType}
              required
              helperText={""}
              data={[
                { label: "Select Car Type", value: "" },
                { label: "Classic", value: "Classic" },
                { label: "Luxury", value: "Luxury" },
                { label: "Super", value: "Super" },
              ]}
            /> */}
            </FieldWrapper>
          </FormRow>
          <FormRow>
            <FieldWrapper>
              <Textfield
                name="carMake"
                label="Purchased Year"
                placeholder="YYYY"
                onChange={handleFormChange}
                value={data?.carMake.toString()}
                required
                helperText={formError["carMake"]}
              />
            </FieldWrapper>
            <FieldWrapper>
              <Textfield
                name="carColor"
                label="Car Color"
                placeholder="Enter colour"
                onChange={handleFormChange}
                value={data?.carColor}
                required
                helperText={formError["carColor"]}
              />
            </FieldWrapper>
          </FormRow>
        </FormWrapper>
      </NoShadowBox>
      <NoShadowBox>
        <div
          style={{
            marginTop: "0.5rem",
            marginBottom: "0.25rem",
            fontSize: "20px",
          }}
        >
          Documents
        </div>

        <RegisterImageUpload
          onFileSelect={(e: any) => handleFileUpload(e, "istimaraPhoto")}
          description={"Only JPEG or PNG files are allowed. Max size: 2MB."}
          label={"Upload Registration Photo / Istimara Here"}
          file={data?.istimaraPhoto}
          name="istimaraPhoto"
          error={formError["istimaraPhoto"]}
        />

        <RegisterImageUpload
          onFileSelect={(e: any) => handleFileUpload(e, "carPhoto")}
          description={"Only JPEG or PNG files are allowed. Max size: 2MB."}
          label={"Upload Car Photo"}
          file={data?.carPhoto}
          name="carPhoto"
          error={formError["carPhoto"]}
        />

        <ActionRow>
          <ButtonWrapper>
            <Button
              variant="outlined"
              label="Cancel"
              onClick={() => navigate("/admin/amd-membership")}
              width="9.7rem"
            />
            <Button
              color={Colors.red}
              variant="filled"
              label="Register"
              width="9.7rem"
              onClick={handleSubmitData}
            />
          </ButtonWrapper>
        </ActionRow>
      </NoShadowBox>
    </Container>
  );
};

const Header = styled.div`
  width: 50%;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const ButtonContainerBack = styled.div`
  width: 50%;
  display: flex;
  justify-content: flex-end;
  @media only screen and (max-width: 768px) {
    width: 100%;
    margin-top: 1rem;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 0.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const Container = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const ButtonWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
    margin-top: 2rem;
  }
  @media only screen and (max-width: 350px) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

const ActionRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
`;

const FieldWrapper = styled.div`
  flex: 1;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const NoShadowBox = styled.div`
  @media only screen and (max-width: 768px) {
    padding: 0 1.5rem;
    box-sizing: border-box;
  }
`;

export default RegisterAMDMembership;
